import CookieBox          from '@/pages/Settings/components/CookieBox';
import LanguageBox        from '@/pages/Settings/components/LanguageBox';
import PageContainer      from '@/components/pageContainer/PageContainer';
import PageTitle          from '@/components/pageTitle/PageTitle';
import { useTranslation } from 'react-i18next';

const SettingsPage = () => {
	const { t } = useTranslation();

	return (
		<PageContainer>
			<PageTitle>
				{t('pages.settings.label')}
			</PageTitle>
			<LanguageBox />
			<CookieBox />
		</PageContainer>
	)
}

export default SettingsPage;